<fieldset>
  <div class="is-flex is-align-items-center is-gap-1">
    <h3>{{ 'tarificateur.franchise' | translate }}</h3>
    <acs-info-bulle
      infoBulleMessage="{{ 'tarificateur.franchise.tooltip' | translate }}">
    </acs-info-bulle>
  </div>
  <mat-form-field class="width-full">
    <mat-select id="franchise" [formControl]="fc">
      <mat-option [value]="0">{{
          'tarificateur.withoutfranchise' | translate
        }}</mat-option>
      @for (deductible of deductibles; track deductible) {
        <mat-option [value]="deductible">
          {{ deductible | currencyFormat }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</fieldset>
